import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2RankingDialogProperties extends BasicDialogProperties {
    public static TAB_RANKING: number = 3;
    public static TAB_TOURNAMENTRANKING: number = 4;
    public static TAB_HALL_OF_FAME: number = 5;

    public tabIndex: number = 0;

    constructor(tabIndex: number) {
        super();

        this.tabIndex = tabIndex;
    }
}
